;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();import { PHONE_COUNTRY_CODES, PHONE_EXPECTED_LENGTHS } from '@/consts/locales';
import { LOCALES } from '@/i18nConfig';
import { Lang } from '@/types/locales';

export const removeNonDigitsFromPhoneNumber = (phoneNumber: string): string =>
  `+${phoneNumber.replace(/[^\d]/g, '')}`;

export const removeCountryCodeFromPhoneNumber = (phoneNumber: string): string =>
  phoneNumber.replace(/^\+\d+/, '');

export const cleanPhoneNumber = (phoneNumber: string, lang?: Lang): string => {
  if (!phoneNumber) {
    return '';
  }

  // Special handling for NZ numbers with +64 prefix
  if (lang === LOCALES.EN_NZ || phoneNumber.startsWith(`+${PHONE_COUNTRY_CODES[LOCALES.EN_NZ]}`)) {
    return getNZPhoneDigits(phoneNumber);
  }

  // Remove all non-digit characters first
  let cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');

  if (!lang) {
    return cleanedPhoneNumber;
  }

  // Get country code and expected length for the locale
  const countryCode = PHONE_COUNTRY_CODES[lang as keyof typeof PHONE_COUNTRY_CODES];
  const expectedLength = PHONE_EXPECTED_LENGTHS[lang as keyof typeof PHONE_EXPECTED_LENGTHS];

  if (!countryCode || !expectedLength) {
    return cleanedPhoneNumber;
  }

  // Remove country code if number starts with it and has expected length
  if (cleanedPhoneNumber.startsWith(countryCode)) {
    const hasExpectedLength =
      lang === LOCALES.EN_AU || lang === LOCALES.EN_HK || lang === LOCALES.ZH_HK
        ? cleanedPhoneNumber.length >= expectedLength
        : cleanedPhoneNumber.length === expectedLength;

    if (hasExpectedLength) {
      cleanedPhoneNumber = cleanedPhoneNumber.substring(countryCode.length);
    }
  }

  return cleanedPhoneNumber;
};

export const getNZPhoneDigits = (formattedValue: string): string => {
  // Extract just the digits after +64
  return formattedValue
    .replace(new RegExp(`^\\+${PHONE_COUNTRY_CODES[LOCALES.EN_NZ]}\\s?`), '')
    .replace(/\D/g, '');
};

export const getPhoneNumberMask = (lang: Lang): string => {
  switch (lang) {
    case LOCALES.EN_CA:
      return `+${PHONE_COUNTRY_CODES[LOCALES.EN_CA]} (999) 999-9999`;
    case LOCALES.EN_AU:
      return `+${PHONE_COUNTRY_CODES[LOCALES.EN_AU]} 9 9999 9999`;
    case LOCALES.EN_HK:
    case LOCALES.ZH_HK:
      return `+${PHONE_COUNTRY_CODES[LOCALES.EN_HK]} 9999 9999`;
    case LOCALES.EN_NZ:
      return `+${PHONE_COUNTRY_CODES[LOCALES.EN_NZ]} 999 99999999`;
    case LOCALES.EN_PL:
    case LOCALES.PL_PL:
      return `+${PHONE_COUNTRY_CODES[LOCALES.EN_PL]} 999 999 999`;
    default:
      return `+${PHONE_COUNTRY_CODES[LOCALES.EN_CA]} (999) 999-9999`;
  }
};

export const validatePhoneNumberLength = (phoneNumber: string, lang: Lang): boolean => {
  const digits = cleanPhoneNumber(phoneNumber, lang);

  if (lang === LOCALES.EN_HK || lang === LOCALES.ZH_HK) {
    return digits.length >= 8;
  }

  return digits.length >= 9;
};

export const getPhoneNumberPlaceholder = (lang: Lang): string => {
  switch (lang) {
    case LOCALES.EN_CA:
      return '+1 (___) ___-____';
    case LOCALES.EN_AU:
      return '+61 _ ____ ____';
    case LOCALES.EN_HK:
      return '+852 ____ ____';
    case LOCALES.EN_NZ:
      return '+64 ';
    case LOCALES.EN_PL:
    case LOCALES.PL_PL:
      return '+48 ___ ___ ___';
    default:
      return '+1 (___) ___-____';
  }
};
